import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../App/redux/store';
import { APIStatus } from '../../services/axiosEnums';
import getIdFromIdIri from '../../shared/parsers/getIdFromIdIri';
import {
  askForSubscriptionUpdateThunk,
  fetchSubscriptionThunk,
} from './services/subscriptionThunks';

const initialState: SubscriptionState = {
  subscriptionIdIri: null,
  subscriptionId: null,
  subscription: { apiStatus: APIStatus.IDLE, result: null, error: undefined },
  subscriptionUpdateRequest: {
    apiStatus: APIStatus.IDLE,
    result: null,
    error: undefined,
  },
  subscriptionCities: null,
  subscriptionDepartments: null,
};

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    setSubscriptionIdIri: (state, action: PayloadAction<string | null>) => {
      state.subscriptionIdIri = action.payload;
      state.subscriptionId = action.payload ? getIdFromIdIri(action.payload) : null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubscriptionThunk.pending, (state) => {
        state.subscription.apiStatus = APIStatus.PENDING;
        state.subscription.error = undefined;
      })
      .addCase(
        fetchSubscriptionThunk.fulfilled,
        (state, action: PayloadAction<SubscriptionParserResult>) => {
          const ap = action.payload;
          state.subscription.apiStatus = APIStatus.IDLE;

          state.subscriptionIdIri = ap.subscription.idIri;
          state.subscriptionId = ap.subscription.id;
          state.subscription.result = ap.subscription;
          state.subscriptionCities = ap.cities;
          state.subscriptionDepartments = ap.departments;
          state.subscriptionUpdateRequest.result = ap.subscriptionsDemands;

          state.subscription.error = undefined;
        },
      )
      .addCase(fetchSubscriptionThunk.rejected, (state, action) => {
        state.subscription.apiStatus = APIStatus.REJECTED;
        state.subscription.error = action.error;
      });
    builder
      .addCase(askForSubscriptionUpdateThunk.pending, (state) => {
        state.subscriptionUpdateRequest.apiStatus = APIStatus.PENDING;
        state.subscriptionUpdateRequest.error = undefined;
      })
      .addCase(
        askForSubscriptionUpdateThunk.fulfilled,
        (state, action: PayloadAction<string>) => {
          state.subscriptionUpdateRequest.apiStatus = APIStatus.PENDING;
          state.subscriptionUpdateRequest.result =
            state.subscriptionUpdateRequest.result?.concat(action.payload) ?? [
              action.payload,
            ];
          state.subscriptionUpdateRequest.error = undefined;
        },
      )
      .addCase(askForSubscriptionUpdateThunk.rejected, (state, action) => {
        state.subscriptionUpdateRequest.apiStatus = APIStatus.REJECTED;
        state.subscriptionUpdateRequest.error = action.error;
      });
  },
});

export default subscriptionSlice.reducer;
export const subscriptionActions = subscriptionSlice.actions;
export const getSubscriptionState = (state: RootState) => state.subscription;
